<template>
  <div @click="handleItemClick">
    <dd-card
      class="compact-inbox-item"
      :class="{
        'border-primary-less-transparent' : isChecked && !isViewing,        
        'bg-color-grey-transparent'  : isViewing,
        }"
      :style="[isChecked && email.id !== firstSelectedEmail.id ? {borderWidth: 1, borderStyle: 'solid'} : {}]"
    >
      <div id="sender" style="width: 85%">
        <div v-if="email.customer_id && email.customer" class="flex-row gap-xxs">
          <dd-avatar :customer-id="email.customer_id" :size="22" />
          <p class="font-medium">{{customerName(email)}}</p>
        </div>
        <div v-else class="flex-row gap-xxs">
          <BadgeComponent size="md"/>
          <p class="font-medium">{{email.from}}</p>
        </div>
      </div>
      <p>{{email.subject}}</p>
      <p>{{format(email.date)}}</p>
      <div class="compact-inbox-item-checkbox">
        <CompactActions
          v-if="showActionButtons"
          :row="email"
          class="compact-action-buttons"
          @mouseleave.native="hideActionButtons"
        />
        <dd-icon
          icon="mdi mdi-dots-horizontal color-grey mr-xxs"
          size="lg"
          @mouseenter.native="startHoverOnDots"
          @mouseleave.native="stopHoverOnDots"
        />
        <input
          ref="checkbox"
          type="checkbox"
          class="m-0"
          :checked="isChecked"
          :value="email.id"
          @click.stop="handleCheckboxClick"
        />
      </div>
    </dd-card>
  </div>
</template>

<script>
import moment from 'moment';
import DateFormatsEnum from "~/enums/DateFormatEnum";
import CustomerUtils from '~/util/customer';
import CompactActions from './email_action_buttons/CompactListActions.vue';
import BadgeComponent from './BadgeComponent.vue'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CompactInboxListItemComponent.vue",
  emits: [ 'select-item' ],
  props: {
    email: { required: true },
    ctrlKey: Boolean
  },
  components: {
    CompactActions,
    BadgeComponent
  },
  data(){
    return {
      hoveringOnDots: false,
      showActionButtons: false
    };
  },
  methods: {
    ...mapActions('email', [
        "showViewEmail"
    ]),
    format(date){
      return moment(date).format(DateFormatsEnum.NEW_DISPLAY_DATE);
    },
    customerName(email){
      return CustomerUtils.getFullName(email.customer.data);
    },
    handleItemClick(){
      if ( this.ctrlKey ){
        this.$refs.checkbox.click();
      } else {
        this.showViewEmail([this.email.id]);
      }
    },
    handleCheckboxClick(e){
      if (this.selectedEmails.length === 1 && this.selectedEmails[0].id === this.email.id) return;
      this.$emit('select-item', this.email);
    },
    startHoverOnDots(){
      this.hoveringOnDots = true;
      setTimeout(() => {
        if ( this.hoveringOnDots ) {
          this.showActionButtons = true;
          this.hoveringOnDots = false;
        }
      }, 1000);
    },
    stopHoverOnDots(){
      this.hoveringOnDots = false;
    },
    hideActionButtons(){
      this.showActionButtons = false;
    }
  },
  computed: {
    ...mapGetters("email", [ 
      "firstSelectedEmail",
      'selectedEmails'
    ]),
    isChecked(){
      return this.selectedEmails.some((email) => email.id === this.email.id);
    },
    isViewing(){
      return this.email.id === this.firstSelectedEmail.id;
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.compact-inbox-item{
  position: relative;
  padding: $spacing-sm !important;
}
.compact-inbox-item:hover{
  cursor: pointer;
}
.compact-inbox-item p {
  margin: 0;
  width: 92%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.compact-inbox-item-checkbox{
  position: absolute;
  right: $spacing-xxs;
  top: $spacing-xs;
  display: flex;
}
.compact-action-buttons {
  position: absolute;
  top: -1;
  right: -1;
}
</style>
